export const IMAGE_SEARCH_SEARCHING = 'IMAGE_SEARCH_SEARCHING';
export const IMAGE_SEARCH_LOAD_MORE_IMAGES = 'IMAGE_SEARCH_LOAD_MORE_IMAGES';
export const IMAGE_SEARCH_IMAGE_SOURCE_UPDATED = 'IMAGE_SEARCH_IMAGE_SOURCE_UPDATED';
